
import CV from "../../FW20-0165-Dhanush-Saji-Resume.pdf";
import { FiDownload } from "react-icons/fi";
import { motion } from "framer-motion";
function CTA() {
  const handleOpen = () => {
    window.open('https://drive.google.com/file/d/1LnDELqmsSno74nvnT0gauPqDBw8uhtqD/view?usp=share_link', "_blank");
  };
  return (
    <div className="cta">
      <motion.a
        initial={{ y: 30,opacity:0 }}
        animate={{ y: 0,opacity:1 }}
        transition={{ duration: 2,ease: "easeIn",type: "spring", stiffness: 300, damping: 20 }}
        href={CV}
        download='FW20-0165-Dhanush-Saji-Resume.pdf'
        className="btn"
        onClick={handleOpen}
      >
        Resume
        <FiDownload />
      </motion.a>
      <motion.a initial={{ y: 30,opacity:0 }}
        animate={{ y: 0,opacity:1 }}
        transition={{ duration: 2,ease: "easeIn",type: "spring", stiffness: 300, damping: 20 }} href="#contact" className="btn-primary">
        Let's talk
      </motion.a>
    </div>
  );
}

export default CTA;
